import { Card, Col, message, Row, Spin } from "antd";
import { Content } from "antd/es/layout/layout";
import styles from "./dashboard.module.scss";
import DashboardHeader from "./DashboardHeader";
import TotalItems from "./TotalItems";
import TotalPieces from "./TotalPieces";
import SpendByTemplate from "./SpendByTemplate";
import LeadsSummary from "./LeadsSummary";
import { useContext, useEffect, useRef, useState } from "react";
import moment from "moment";
import { dashboardService } from "../../services";
import OrderSummary from "./OrderSummary";
import DeliveryMethodSummary from "./DeliveryMethodSummary";
import { AuthContext } from "../../context/AuthProvider";

const defaultEnd = moment();
const defaultStart = moment().startOf("month");

const DashboardPage: React.FC = () => {
  const printRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [spendData, setSpendData] = useState<any>(null);
  const [filters, setFilters] = useState<[string[] | null, string] | null>(
    null,
  );
  const { user, selectedSwitcherAccountId } = useContext(AuthContext);

  useEffect(() => {
    setFilters([
      [defaultStart.format("MM/DD/YYYY"), defaultEnd.format("MM/DD/YYYY")],
      "mtd",
    ]);
  }, [selectedSwitcherAccountId]);

  useEffect(() => {
    const getDashboardData = async () => {
      if (filters?.[0]?.length) {
        try {
          setLoading(true);
          const payload: any = {
            startDate: moment(filters[0][0]).format("YYYY-MM-DD"),
            endDate: moment(filters[0][1]).format("YYYY-MM-DD"),
            accountId: selectedSwitcherAccountId || user?.accountId || '',
          };
          if (filters[1]) {
            payload.period = filters[1];
          }
          const [summaryResult, spendResult] = await Promise.allSettled([
            dashboardService.getDashboardSummary(payload),
            dashboardService.getSpendByTemplate(payload),
          ]);
          if (summaryResult.status === "fulfilled") {
            setDashboardData(summaryResult.value);
          } else {
            const msg = summaryResult.reason?.message || "Failed to fetch dashboard summary";
            console.error(msg);
            message.error(msg);
          }
          if (spendResult.status === "fulfilled") {
            setSpendData(spendResult.value);
          } else {
            const msg = spendResult.reason?.message || "Failed to fetch spend by template";
            console.error(msg);
            message.error(msg);
          }
        } catch (e: any) {
          console.log(e?.message || "Something went wrong when fetching data");
          message.error(
            e?.message || "Something went wrong when fetching data",
          );
        } finally {
          setLoading(false);
        }
      }
    };
    getDashboardData();
  }, [filters, user, selectedSwitcherAccountId]);

  return (
    <Content style={{ padding: "20px 24px" }}>
      <DashboardHeader
        key={selectedSwitcherAccountId}
        printRef={printRef}
        filters={filters}
        setFilters={setFilters}
      />
      <Spin spinning={loading} fullscreen />
      <Row gutter={[10, 10]} ref={printRef}style={{marginTop: '20px'}}>
        <Col xs={24} md={12} lg={12}>
          <Row gutter={[10, 10]} style={{ height: "calc(100vh - 119px)" }}>
            <Col xs={24} style={{ height: "50%" }}>
              <Card style={{ height: "100%", borderRadius: '10px', boxShadow: 'none' }} className={styles.orderSummaryCard} variant="borderless">
                <OrderSummary templateAggregations={dashboardData?.templateAggregations}/>
              </Card>
            </Col>
            <Col xs={24} md={12} lg={12} style={{ height: "50%" }}>
              <Card
                variant="borderless"
                style={{ height: "100%", borderRadius: '10px', boxShadow: 'none' }}
                styles={{ body: { height: "100%", padding: "16px" } }}
              >
                <LeadsSummary dashboardData={dashboardData} filters={filters} />
              </Card>
            </Col>
            <Col xs={24} md={12} lg={12} style={{ height: "50%" }}>
              <Card
               style={{ height: "100%", borderRadius: '10px', boxShadow: 'none' }}
               variant="borderless"
               styles={{ body: { height: "100%", padding: "16px" } }}
               >
                <DeliveryMethodSummary dashboardData={dashboardData} />  
              </Card>
            </Col>
          </Row> 
        </Col>
        <Col xs={24} md={12} lg={12}>
          <Row gutter={[10, 10]} style={{ height: "calc(100vh - 119px)" }}>
            <Col xs={24} md={12} lg={12} style={{ height: "138px" }}>
              <Card
                variant="borderless"
                style={{ height: "100%", borderRadius: '10px', boxShadow: 'none' }}
                bodyStyle={{
                  height: "100%",
                  padding: "20px",
                }}
              >
                <TotalItems
                  dashboardData={dashboardData}
                  filters={filters}
                />
              </Card>
            </Col>
            <Col xs={24} md={12} lg={12} style={{ height: "138px" }}>
              <Card
                variant="borderless"
                style={{ height: "100%", borderRadius: '10px', boxShadow: 'none' }}
                bodyStyle={{
                  height: "100%",
                  padding: "20px",
                }}
              >
                <TotalPieces
                  dashboardData={dashboardData}
                  filters={filters}
                />
              </Card>
            </Col>
            <Col xs={24} style={{ height: "calc(-258px + 100vh)" }}>
              <Card
                style={{ height: "100%", borderRadius: '10px', boxShadow: 'none' }}
                variant="borderless"
                styles={{ body: { height: "100%", padding: "16px", overflow: "hidden" } }}
              >
                <SpendByTemplate spendData={spendData} dashboardData={dashboardData} filters={filters} />
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Content>
  );
};

export default DashboardPage;
